import { css } from '@emotion/react';

export const getLegalStatementTextColor = ({ theme }) =>
  theme.mvf.palette.text.legalStatementTextColor ?? '#808080';

export const getLegalStatementLinkColor = ({ theme }) =>
  theme.mvf.palette.text.legalStatementLinkColor;

const makeLegalStatementStyling = ({ theme }) => {
  return {
    legalStatement: css({
      marginTop: theme.mvf.spacing.small,
      marginBottom: theme.mvf.spacing.medium,
      '& p span': {
        color: getLegalStatementTextColor({ theme }),
        fontSize: `${theme.mvf.fontSize.originalTiny}px !important`,
        [theme.breakpoints.up('tabletSmall')]: {
          fontSize: `${theme.mvf.fontSize.originalLittle}px !important`,
        },
      },
      '& p span a': {
        color: getLegalStatementLinkColor({ theme }),
      },
    }),
  };
};

export default makeLegalStatementStyling;
